module.exports = __webpack_public_path__ + "img/victron_24A_24V.ddae9805.png";